import { Language } from '@/utilities/language';

export function getBannerCode(language: Language) {
  switch (language) {
    case Language.Czech:
      return 'cc';
    case Language.Slovak:
      return 'cs';
    default:
      throw new Error(`Unknown language: ${language}`);
  }
}
